/**
 * Interface for nofitication item
 *
 * @interface NotificationItem
 */
export interface NotificationItem {
  /**
   * @member {string} message notification message
   */
  message: string;
  /**
   * @member {NotificationType} messageType type of message
   */
  messageType: NotificationType;
  /**
   * @member {boolean} acrossRoutes Set to true for showing notification after redirection
   */
  acrossRoutes: boolean;
  /**
   * @member {boolean} disableTimeout Set to false for deleting the notification after 5 sec and true for keeping it persistent.
   */
  disableTimeout?: boolean;
}

/**
 * @enum {number} Notification types
 */
export enum NotificationType {
  Success,
  Error,
  Info,
  Warning,
}
